module.exports = __webpack_public_path__ + "media/alaska/bear-d4a0ca31.jpg";